import type { Precision } from "@/types";

export const PRECISION_OPTIONS: Array<{
  value: Precision;
  label: string;
  description: string;
}> = [
  { value: 4, label: "4-bit", description: "Maximum efficiency" },
  { value: 8, label: "8-bit", description: "Fast & balanced" },
  { value: 16, label: "16-bit", description: "High fidelity" },
  { value: 32, label: "32-bit", description: "Research-grade" }
];

export const PRECISION_ORDER = PRECISION_OPTIONS.map(option => option.value);

export function findPrecisionOption(value: Precision) {
  return PRECISION_OPTIONS.find(option => option.value === value) ?? PRECISION_OPTIONS[1];
}

